let attemptNo = 0;
const maxAttempts = 10;

export default function retrieveUserDataRepeatedSocial(dispatch) {
	console.info("called retrieveUserDataRepeatedSocial.");
	return dispatch('RETRIEVE_USER_DATA_SOCIAL')
		.then(() => {
			console.log('RETRIEVE_USER_DATA_SOCIAL then');
			attemptNo = 0;
		})
		.catch((err) => {
			console.log('RETRIEVE_USER_DATA_SOCIAL catch');
			
			if (attemptNo < maxAttempts) {
				attemptNo++;

				console.info("attemptNo", attemptNo);
				return retrieveUserDataRepeatedSocial(dispatch);
			}

			return dispatch('RETRIEVE_USER');
		});
}
